"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MTGMultiRequestProcessor = exports.MTGMultiAppProcessor = exports.MTG_QUOTE = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const TextAndSliderSyncTool_1 = require("../CommonUtils/TextAndSliderSyncTool");
const MartingaleAppProcessor_1 = require("./MartingaleAppProcessor");
const MartingaleTradingTools_1 = require("./MartingaleTradingTools");
exports.MTG_QUOTE = "USDT";
const MTGMultiAppProcessor = (props) => {
    const { tradeApi, sub_order_type = TradeAPILib_1.MartingaleSubType.normal, invest, investPercent, investActionType, balance, safetyOrders, takeProfitRatio, priceScaleParams, priceScaleType, orderType, MTGMultiCoins, volume_scale, take_profit_trailing_percentage, price_scale_trailing_percentage, stop_profit_percentage, stop_loss_percentage, unrealized_stop_loss_percentage, signal, max_active_coins, max_active_safety_orders, precision, updateSignal, } = props;
    const parseBalance = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(balance, precision);
    const [parseInvest, parseInvestPercent] = TextAndSliderSyncTool_1.TextAndSliderSyncTool.useGridInvestAndInvestPercent(investActionType, invest, investPercent, parseBalance, precision);
    const [isPriceScaleError, isPriceScaleTrailingError, isTakeProfitError, isTakeProfitTrailingError] = (0, react_1.useMemo)(() => {
        let priceScaleError = false;
        if (priceScaleParams && priceScaleType === TradeAPILib_1.MartingalePriceScaleType.percentage) {
            const min = sub_order_type === TradeAPILib_1.MartingaleSubType.normal
                ? MartingaleTradingTools_1.MartingalePriceScalePercentageMin
                : MartingaleTradingTools_1.MartingalePriceScalePercentageMin_SmartTradeMode;
            const realValue = new trade_utils_lib_1.SafeDecimal(priceScaleParams).div(100);
            priceScaleError = realValue.lessThan(min) || realValue.greaterThan(MartingaleTradingTools_1.MartingalePriceScalePercentageMax);
        }
        let priceScaleTrailingError = false;
        if (sub_order_type === TradeAPILib_1.MartingaleSubType.smart_trade &&
            priceScaleType !== TradeAPILib_1.MartingalePriceScaleType.custom &&
            price_scale_trailing_percentage) {
            const realValue = new trade_utils_lib_1.SafeDecimal(price_scale_trailing_percentage).div(100);
            priceScaleTrailingError = realValue.lessThan(MartingaleTradingTools_1.MartingalePriceScaleTrailingPercentageMin);
            if (priceScaleParams && !priceScaleError) {
                priceScaleTrailingError =
                    priceScaleTrailingError || realValue.greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(priceScaleParams).div(100));
            }
        }
        let takeProfitError = takeProfitRatio.length > 0 && new trade_utils_lib_1.SafeDecimal(takeProfitRatio).div(100).lessThan(MartingaleTradingTools_1.MartingaleTakeProfitRatioMin);
        let takeProfitTrailingError = false;
        if (sub_order_type === TradeAPILib_1.MartingaleSubType.smart_trade && take_profit_trailing_percentage) {
            const realValue = new trade_utils_lib_1.SafeDecimal(take_profit_trailing_percentage).div(100);
            takeProfitTrailingError = realValue.lessThan(MartingaleTradingTools_1.MartingaleTakeProfitTrailingPercentageMin);
            if (takeProfitRatio && !takeProfitError) {
                takeProfitTrailingError =
                    takeProfitTrailingError || realValue.greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(takeProfitRatio).div(100));
            }
        }
        return [priceScaleError, priceScaleTrailingError, takeProfitError, takeProfitTrailingError];
    }, [sub_order_type, priceScaleParams, price_scale_trailing_percentage, takeProfitRatio, take_profit_trailing_percentage]);
    const safetyOrderError = (0, react_1.useMemo)(() => {
        if (priceScaleType === TradeAPILib_1.MartingalePriceScaleType.custom) {
            return;
        }
        const safetyOrderInfo = (0, MartingaleTradingTools_1.getMaxSafetyOrdersByVolumeScale)(volume_scale !== null && volume_scale !== void 0 ? volume_scale : MartingaleTradingTools_1.MartingaleVolumeScaleDefault);
        const isRangeError = new trade_utils_lib_1.SafeDecimal(safetyOrders).lessThan(safetyOrderInfo.minSafetyOrder) ||
            new trade_utils_lib_1.SafeDecimal(safetyOrders).greaterThan(safetyOrderInfo.maxSafeOrder);
        if (isRangeError) {
            return {
                type: MartingaleAppProcessor_1.MartingaleSafeOrderError.rangeError,
                min: safetyOrderInfo.minSafetyOrder,
                max: safetyOrderInfo.maxSafeOrder,
            };
        }
        else {
            return undefined;
        }
    }, [safetyOrders, volume_scale]);
    const runningSum = function (nums) {
        return nums.map((a, index, array) => {
            return array.splice(0, index + 1).reduce((b, c) => b + c, 0);
        });
    };
    const queryMinInvestParams = (0, react_1.useMemo)(() => {
        return {
            exchange: TradeAPILib_1.ExchangeID.PIONEXV2,
            base_list: MTGMultiCoins.symbols.map((a) => a.base),
            quote: MTGMultiCoins.symbols.length > 0 ? MTGMultiCoins.symbols[0].quote : "",
            max_active_coins: Number(max_active_coins),
            volume_scale: Number(volume_scale),
            max_active_safety_orders: Number(max_active_safety_orders),
            safety_orders: Number(safetyOrders),
            price_scale_type: priceScaleType,
            price_scale_param: (() => {
                try {
                    if (typeof priceScaleParams === "string") {
                        return priceScaleParams;
                    }
                    return JSON.stringify({
                        data: priceScaleParams,
                    });
                }
                catch (error) {
                    return "";
                }
            })(),
        };
    }, [MTGMultiCoins.symbols, max_active_coins, volume_scale, max_active_safety_orders, safetyOrders, priceScaleType, priceScaleParams]);
    const [minInvest, minInvestDisplay, minInvestLoading, minInvestError] = (0, MartingaleTradingTools_1.useMTGMultiMinInvest)(tradeApi, queryMinInvestParams);
    const investState = (0, react_1.useMemo)(() => {
        const state = {
            state: "normal",
            min: minInvest,
            max: parseBalance,
        };
        if (parseInvest) {
            if (new trade_utils_lib_1.SafeDecimal(parseInvest).greaterThan(new trade_utils_lib_1.SafeDecimal(parseBalance))) {
                state.state = "large";
            }
            else if (new trade_utils_lib_1.SafeDecimal(parseInvest).lessThan(new trade_utils_lib_1.SafeDecimal(minInvest))) {
                state.state = "small";
            }
        }
        return state;
    }, [parseInvest, minInvest, parseBalance]);
    const emptyErrors = (0, react_1.useMemo)(() => {
        const emptys = [];
        if (!priceScaleParams) {
            emptys.push("martingale_price_scale");
        }
        if (sub_order_type === TradeAPILib_1.MartingaleSubType.smart_trade &&
            priceScaleType !== TradeAPILib_1.MartingalePriceScaleType.custom &&
            !price_scale_trailing_percentage) {
            emptys.push("martingale_price_scale_trailing_percentage");
        }
        if (!takeProfitRatio) {
            emptys.push("martingale_take_profit_ratio");
        }
        if (sub_order_type === TradeAPILib_1.MartingaleSubType.smart_trade &&
            priceScaleType !== TradeAPILib_1.MartingalePriceScaleType.custom &&
            !take_profit_trailing_percentage) {
            emptys.push("martingale_take_profit_trailing_percentage");
        }
        if (!parseInvest) {
            emptys.push("trading_total_investment");
        }
        if (!safetyOrders && priceScaleType !== TradeAPILib_1.MartingalePriceScaleType.custom && sub_order_type !== TradeAPILib_1.MartingaleSubType.smart_trade) {
            emptys.push("martingale_safety_orders");
        }
        return emptys;
    }, [parseInvest, priceScaleParams, takeProfitRatio, safetyOrders, sub_order_type, priceScaleType, take_profit_trailing_percentage]);
    return {
        sub_order_type,
        priceScale: priceScaleParams,
        priceScaleMode: priceScaleType,
        takeProfitRatio: takeProfitRatio,
        invest: parseInvest,
        investPercent: parseInvestPercent,
        safetyOrders: safetyOrders,
        isPriceScaleError: isPriceScaleError,
        isPriceScaleTrailingError: isPriceScaleTrailingError,
        isTakeProfitError: isTakeProfitError,
        isTakeProfitTrailingError: isTakeProfitTrailingError,
        safetyOrderError: safetyOrderError,
        availableBalance: parseBalance,
        MTGMultiCoins: MTGMultiCoins,
        orderType: orderType,
        investState: investState,
        minInvestInfo: { minInvest, minInvestDisplay, minInvestLoading, minInvestError },
        emptyErrors: emptyErrors,
        priceScalePercentageMinDisplay: sub_order_type === TradeAPILib_1.MartingaleSubType.normal ? MartingaleAppProcessor_1.PriceScalePercentageMinDisplay : MartingaleAppProcessor_1.PriceScalePercentageMinDisplay_SmartTradeMode,
        priceScalePercentageMaxDisplay: MartingaleAppProcessor_1.PriceScalePercentageMaxDisplay,
        priceScaleTrailingPercentageMinDisplay: MartingaleAppProcessor_1.PriceScaleTrailingPercentageMin,
        takeProfitTrailingPercentageMinDisplay: MartingaleAppProcessor_1.TakeProfitTrailingPercentageMin,
        precision: precision,
        volume_scale: volume_scale,
        take_profit_trailing_percentage: take_profit_trailing_percentage !== null && take_profit_trailing_percentage !== void 0 ? take_profit_trailing_percentage : "",
        price_scale_trailing_percentage: price_scale_trailing_percentage !== null && price_scale_trailing_percentage !== void 0 ? price_scale_trailing_percentage : "",
        stop_profit_percentage: stop_profit_percentage,
        stop_loss_percentage: stop_loss_percentage,
        unrealized_stop_loss_percentage: unrealized_stop_loss_percentage,
        signal: signal,
        max_active_safety_orders: max_active_safety_orders,
        max_active_coins,
    };
};
exports.MTGMultiAppProcessor = MTGMultiAppProcessor;
const MTGMultiRequestProcessor = (params, $st) => {
    var _a, _b, _c, _d;
    if (params.sub_order_type === TradeAPILib_1.MartingaleSubType.smart_trade) {
    }
    if (params.priceScaleMode === TradeAPILib_1.MartingalePriceScaleType.custom) {
        if (Array.isArray(params.priceScale) && params.priceScale.length < 1) {
            throw $st("error_martingale_DIY_price_scale_length_low");
        }
    }
    let price_scale = "";
    if (params.priceScaleMode === TradeAPILib_1.MartingalePriceScaleType.percentage) {
        const priceScale = new trade_utils_lib_1.SafeDecimal(params.priceScale).div(100);
        if (priceScale.lessThan(MartingaleTradingTools_1.MartingalePriceScalePercentageMin) || priceScale.greaterThan(MartingaleTradingTools_1.MartingalePriceScalePercentageMax)) {
            throw $st("number_input_range_error", {
                min: MartingaleAppProcessor_1.PriceScalePercentageMinDisplay,
                max: MartingaleAppProcessor_1.PriceScalePercentageMaxDisplay,
            });
        }
        price_scale = priceScale.toString();
    }
    else if (params.priceScaleMode === TradeAPILib_1.MartingalePriceScaleType.custom) {
        const arr = params.priceScale;
        if (Array.isArray(arr)) {
            const parseArr = arr.map((e) => {
                const item = {
                    price_scale: new trade_utils_lib_1.SafeDecimal(e.price_scale).div(100).toString(),
                    shares: e.shares,
                };
                if (e.tp) {
                    item["tp"] = new trade_utils_lib_1.SafeDecimal(e.tp).div(100).toString();
                }
                return item;
            });
            const data = { data: parseArr };
            price_scale = JSON.stringify(data);
        }
    }
    else if (params.priceScaleMode === TradeAPILib_1.MartingalePriceScaleType.fixed_num) {
    }
    else {
        price_scale = params.priceScale;
    }
    const takeProfitRatioD = new trade_utils_lib_1.SafeDecimal(params.takeProfitRatio).div(100);
    if (takeProfitRatioD.lessThan(MartingaleTradingTools_1.MartingaleTakeProfitRatioMin)) {
        throw $st("martingale_take_profit_ratip_min_error", {
            min: new trade_utils_lib_1.SafeDecimal(MartingaleTradingTools_1.MartingaleTakeProfitRatioMin).mul(100).toString() + "%",
        });
    }
    if (params.investState.state === "small") {
        throw $st("trade_error_low_cost", {
            cost: `${(_a = params.minInvestInfo) === null || _a === void 0 ? void 0 : _a.minInvest} ${exports.MTG_QUOTE}`,
        });
    }
    else if (params.investState.state === "large") {
        throw $st("trade_error_balance_not_enough");
    }
    if (params.safetyOrderError && params.safetyOrderError.type === MartingaleAppProcessor_1.MartingaleSafeOrderError.rangeError) {
        throw $st("number_input_range_error", {
            min: params.safetyOrderError.min,
            max: params.safetyOrderError.max,
        });
    }
    const innerCoin = params.MTGMultiCoins.symbols.map((a) => {
        var _a, _b, _c;
        const tempCoin = {
            base: a.base,
            price_scale_type: params.priceScaleMode,
            price_scale_param: price_scale,
            take_profit_ratio: takeProfitRatioD.toString(),
            safety_orders: new trade_utils_lib_1.SafeDecimal(params.safetyOrders).toNumber(),
            max_active_safety_orders: params.max_active_safety_orders,
            signal_type: (_a = params.signal) === null || _a === void 0 ? void 0 : _a.type,
            signal_param: typeof ((_b = params.signal) === null || _b === void 0 ? void 0 : _b.param) === "object" ? JSON.stringify(params.signal.param) : (_c = params.signal) === null || _c === void 0 ? void 0 : _c.param,
        };
        if (params.volume_scale) {
            tempCoin["volume_scale"] = params.volume_scale;
        }
        return tempCoin;
    });
    if (((_b = params.signal) === null || _b === void 0 ? void 0 : _b.type) === "time_lapse" && params.signal.param && params.signal.param.time) {
        const time = new trade_utils_lib_1.SafeDecimal(params.signal.param.time);
        if (time.greaterThan(86400)) {
            // 秒数可以填1-86400, 也就是1-24小时
            throw $st("martingale_signal_param_time_lapse_time_error", { min: 1, max: 86400 });
        }
    }
    if (((_c = params.signal) === null || _c === void 0 ? void 0 : _c.type) === "time_lapse" || ((_d = params.signal) === null || _d === void 0 ? void 0 : _d.type) === "immediately") {
        if (!new trade_utils_lib_1.SafeDecimal(params.max_active_coins).equals(params.MTGMultiCoins.symbols.length)) {
            throw $st("martingale_max_active_coins_error");
        }
    }
    if (new trade_utils_lib_1.SafeDecimal(params.max_active_safety_orders).greaterThan(params.safetyOrders)) {
        throw $st("martingale_max_active_safet_order_error");
    }
    // if (new SafeDecimal(params.max_active_safety_orders).equals(0)) {
    //     throw $st("martingale_max_active_safet_order_zero_error");
    // }
    const processPercentage = (value, lowError) => {
        let result;
        if (value) {
            result = new trade_utils_lib_1.SafeDecimal(value).div(100).toNumber();
            if (result < -1) {
                throw lowError;
            }
        }
        return result;
    };
    const stop_loss_percentage = processPercentage(params.stop_loss_percentage, $st("martingale_error_stop_loss_percentage_min", { min: "-100%" }));
    const unrealized_stop_loss_percentage = processPercentage(params.unrealized_stop_loss_percentage, $st("martingale_error_unrealized_stop_loss_percentage_min", {
        min: "-100%",
    }));
    const stop_profit_percentage = processPercentage(params.stop_profit_percentage, $st("martingale_error_stop_profit_percentage_min", { min: "-100%" }));
    if (stop_loss_percentage !== undefined && unrealized_stop_loss_percentage !== undefined) {
        throw $st("martingale_error_stop_loss_only_active_one");
    }
    return {
        sub_order_type: params.sub_order_type,
        type: params.orderType,
        quote: params.MTGMultiCoins.symbols[0].quote,
        portfolio: innerCoin,
        quote_total_investment: params.invest,
        stop_profit_percentage: stop_profit_percentage,
        stop_loss_percentage: stop_loss_percentage,
        unrealized_stop_loss_percentage: unrealized_stop_loss_percentage,
        is_multi: params.MTGMultiCoins.symbols.length > 1,
        max_active_coins: params.max_active_coins,
    };
};
exports.MTGMultiRequestProcessor = MTGMultiRequestProcessor;
